import { render } from "./providers.vue?vue&type=template&id=ca88a0a8&ts=true"
import script from "./providers.vue?vue&type=script&lang=ts"
export * from "./providers.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__